import React from "react";
import Link from "next/link";
import GrayArrow from "../svg/gray-arrow";

interface BreadcrumbsProps {
    items: Array<{
        text: string;
        href?: string;
    }>;
    style?: "dark" | "light";
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, style }) => {
    return (
        <nav aria-label="breadcrumb" className="max-[576px]:max-w-full max-[576px]:overflow-hidden	">
            <ul className="flex">
                {items.map((item, index) => (
                    <li key={index} className="flex items-center">
                        {item.href ? ( 
                            <Link href={item.href}>
                                <div className="font-inter font-normal text-sm text-gray-500 leading-[114%] whitespace-nowrap">{item.text}</div>
                            </Link>
                        ) : (
                            <span className={`font-semibold text-sm leading-[114%] whitespace-nowrap ${style === "dark" ? "text-violet-400" : 'text-white'}`}>{item.text}</span>
                        )}
                        {index < items.length - 1 && (
                            <span	className="mx-1">
                                <GrayArrow />
                            </span>
                        )}
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default Breadcrumbs;
